import React, { useEffect } from 'react';
import { useAuthState } from './AuthStateProvider';
const OktaError = ({
  error
}) => {
  if (error.name && error.message) {
    return React.createElement("p", null, "".concat(error.name, ": ").concat(error.message));
  }
  return React.createElement("p", null, "Error: ", error.toString());
};
export const LoginCallback = ({
  errorComponent
}) => {
  const _useAuthState = useAuthState(),
    authService = _useAuthState.authService,
    authState = _useAuthState.authState;
  const authStateReady = !authState.isPending;
  const ErrorReporter = errorComponent || OktaError;
  useEffect(() => {
    authService.handleAuthentication();
  }, [authService]);
  if (authStateReady && authState.error) {
    return React.createElement(ErrorReporter, {
      error: authState.error
    });
  }
  return null;
};
OktaError.__docgenInfo = {
  componentName: "OktaError",
  packageName: "@jutro/auth",
  description: "",
  displayName: "OktaError",
  methods: [],
  actualName: "OktaError"
};
LoginCallback.__docgenInfo = {
  componentName: "LoginCallback",
  packageName: "@jutro/auth",
  description: "",
  displayName: "LoginCallback",
  methods: [],
  actualName: "LoginCallback"
};